export const SEEDS_LIST_LABELS = {
	ADD_URL: '+ Add URL',
	CLEAR_LIST: 'Clear list',
	CONFIRM_REMOVING_URLS: 'Confirm removing urls',
	CONFIRM_REMOVING_ALL_URLS: 'Confirm removing all urls',
	DISABLED_REASON: 'Check URLs to enable this button'
} as const;
